// Estimated avg combined state+local sales tax rates (mirror of backend STATE_TAX_RATES).
export const STATE_TAX_RATES = {
  AL: 0.0924, AK: 0.0176, AZ: 0.0838, AR: 0.0947, CA: 0.0882, CO: 0.0777,
  CT: 0.0635, DE: 0.0, FL: 0.07, GA: 0.0738, HI: 0.045, ID: 0.0603,
  IL: 0.0886, IN: 0.07, IA: 0.0694, KS: 0.087, KY: 0.06, LA: 0.0955,
  ME: 0.055, MD: 0.06, MA: 0.0625, MI: 0.06, MN: 0.0749, MS: 0.0707,
  MO: 0.0839, MT: 0.0, NE: 0.0694, NV: 0.0823, NH: 0.0, NJ: 0.066,
  NM: 0.0778, NY: 0.0852, NC: 0.0698, ND: 0.0696, OH: 0.0724, OK: 0.0895,
  OR: 0.0, PA: 0.0634, RI: 0.07, SC: 0.0744, SD: 0.064, TN: 0.0955,
  TX: 0.082, UT: 0.0725, VT: 0.0636, VA: 0.0577, WA: 0.0938, WV: 0.0655,
  WI: 0.0543, WY: 0.0536, DC: 0.06,
};

export const US_STATES = Object.keys(STATE_TAX_RATES).sort();
